import { createContext } from "react";

export default createContext({
  parcelStatusText: null,
  changeParcelStatus: () => {},
});
